<div bsModal #staticModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-static"
     [config]="{backdrop: 'static'}" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            
            <div class="modal-header">
                <h4 id="dialog-static" class="modal-title pull-left">
                    Add New Portfolio
                </h4>

                <button type="button" class="close pull-right" (click)="staticModal.hide()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">                
                <form [formGroup]="formGroup" autocomplete="off">
                    <div class="form-section clear-border">
                        <div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="portfolioName">Portfolio Name <i class="fa fa-asterisk required"></i></label>
                                        <input type="text" name="portfolioName" formControlName="portfolioName" placeholder="Portfolio Name" class="form-control">
                                        <sp-field-error [controlName]="'portfolioName'" [control]="formGroup.controls['portfolioName']"></sp-field-error>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="companyName">Company Name <i class="fa fa-asterisk required"></i></label>
                                        <input type="text" name="companyName" formControlName="companyName" placeholder="Company Name" class="form-control">
                                        <sp-field-error [controlName]="'companyName'" [control]="formGroup.controls['companyName']"></sp-field-error>
                                    </div>
                                </div>                                
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="address">Address</label>
                                        <input type="text" name="address" formControlName="address" placeholder="Address" class="form-control">
                                        <sp-field-error [controlName]="'address'" [control]="formGroup.controls['address']"></sp-field-error>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="address2">Address2</label>
                                        <input type="text" name="address2" formControlName="address2" placeholder="Address2" class="form-control">
                                        <sp-field-error [controlName]="'address2'" [control]="formGroup.controls['address2']"></sp-field-error>
                                    </div>
                                </div>                                
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="state">City</label>
                                        <input type="text" name="city" formControlName="city" placeholder="City" class="form-control">
                                        <sp-field-error [controlName]="'city'" [control]="formGroup.controls['city']"></sp-field-error>
                                    </div>
                                </div>
                                <div class="col-md-6 clear-padding extendable">
                                    <div class="form-group">
                                        <label for="state">State</label>
                                        <select class="sp-select form-control" formControlName="state" class="form-control">
                                            <option *ngFor="let state of states" [value]="state">{{ state }}</option>
                                        </select>
                                        <sp-field-error [controlName]="'state'" [control]="formGroup.controls['state']"></sp-field-error>
                                    </div>
                                </div>                                
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="zip">Zip</label>
                                        <input type="text" name="zip" formControlName="zip" placeholder="Zip" class="form-control">
                                        <sp-field-error [controlName]="'zip'" [control]="formGroup.controls['zip']"></sp-field-error>
                                    </div>
                                </div>
                            </div>
                            
                            <hr>
                            <!-- Contact Section -->
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Contact</h3>
                                </div>
                            </div>
                            
                            <!-- Email Row -->
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="contactName">Contact Name</label>
                                        <input type="text" name="contactName" formControlName="contactName" placeholder="Contact Name" class="form-control">
                                        <sp-field-error [controlName]="'contactName'" [control]="formGroup.controls['contactName']"></sp-field-error>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="email">Email</label>
                                        <input type="email" name="email" formControlName="email" placeholder="Email" class="form-control">
                                        <sp-field-error [controlName]="'email'" [control]="formGroup.controls['email']"></sp-field-error>
                                    </div>
                                </div>
                               
                            </div>
                            <!-- Website Row -->
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="phone">Phone</label>
                                        <input type="text" id="phone" formControlName="phone" placeholder="Phone" class="form-control" pattern="((001[ -]?)?(\d{3}[ -]?\d{3}[ -]?\d{4}))?" />
                                        <span [hidden]="formGroup.controls['phone'].untouched || formGroup.controls['phone'].valid" class="red">
                                            <span *ngIf="formGroup.controls['phone'].errors && formGroup.controls['phone'].errors.pattern">Phone should be like xxx xxx xxxx </span>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="website">Website</label>
                                        <input type="text" name="website" formControlName="website" placeholder="Website" class="form-control" pattern="^(https?):\/\/www\.[a-zA-Z0-9-]+\.[a-z]{2,}$">
                                        <div *ngIf="formGroup.controls['website'].errors && formGroup.controls['website'].pristine" class="error-message">Website should be like http://www.website.com </div>
                                        <span [hidden]="formGroup.controls['website'].untouched || formGroup.controls['website'].valid" class="red">
                                            <span *ngIf="formGroup.controls['website'].errors && formGroup.controls['website'].errors.pattern">Website should be like http://www.website.com </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <!-- Advanced Details Section -->
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Advanced Details</h3>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3 col-sm-12 top-buffer-20">
                                    <label for="whiteLabelSwitch">Allow white label</label>
                                </div>
                                <div class="col-md-8 col-sm-12 top-buffer-20">
                                    <label class="btn-radio-container">
                                        <input type="radio" class="form-control" formControlName="whiteLabelSwitch" [value]="false"><span></span> No
                                    </label>
                                    <label class="btn-radio-container">
                                        <input type="radio" class="form-control" formControlName="whiteLabelSwitch" [value]="true"><span></span> Yes
                                    </label>
                                </div>
                            </div>
                    
                            <div class="row">
                                <div class="col-md-3 col-sm-12 top-buffer-10">
                                    <label for="loanAnalysisSwitch">Enable Loan Analysis Feature</label>
                                </div>
                                <div class="col-md-8 col-sm-12 top-buffer-20">
                                    <label class="btn-radio-container">
                                        <input type="radio" class="form-control" formControlName="loanAnalysisSwitch" [value]="false"><span></span> No
                                    </label>
                                    <label class="btn-radio-container">
                                        <input type="radio" class="form-control" formControlName="loanAnalysisSwitch" [value]="true"><span></span> Yes
                                    </label>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-3 col-sm-12 top-buffer-10">
                                    <label for="featureTogglePreventativeMaintenance">Enable Maintenance Feature</label>
                                </div>
                                <div class="col-md-8 col-sm-12 top-buffer-20">
                                    <label class="btn-radio-container">
                                        <input type="radio" class="form-control" formControlName="featureTogglePreventativeMaintenance" [value]="false"><span></span> No
                                    </label>
                                    <label class="btn-radio-container">
                                        <input type="radio" class="form-control" formControlName="featureTogglePreventativeMaintenance" [value]="true"><span></span> Yes
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>            
            
            <footer class="text-start">
                <button type="button" class="btn btn-cancel" (click)="cancel()">Cancel</button>
                <button type="button" class="btn btn-success" (click)="addPortfolio()" [disabled]="!formGroup?.valid || isSubmitting">Add Portfolio</button>
            </footer>
        </div>
    </div>
</div>
